declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    rdt?: (...args: any[]) => void;
  }
}

export function trackEvent(eventName: string, params?: Record<string, string | number | boolean>) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}

export function trackRedditEvent(eventName: string) {
  if (typeof window.rdt === 'function') {
    window.rdt('track', eventName);
  }
}
